import { PropsWithChildren } from "react";

import { AuthContext } from "./AuthContext";
import { useAuth } from "./useAuth";

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const auth = useAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
